module.exports = __webpack_public_path__ + "img/stinks.08538dea.png";